/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { subscriptionsControllerCancelAllSubscriptions } from '../fn/subscriptions/subscriptions-controller-cancel-all-subscriptions';
import { SubscriptionsControllerCancelAllSubscriptions$Params } from '../fn/subscriptions/subscriptions-controller-cancel-all-subscriptions';
import { subscriptionsControllerCreateSubscription } from '../fn/subscriptions/subscriptions-controller-create-subscription';
import { SubscriptionsControllerCreateSubscription$Params } from '../fn/subscriptions/subscriptions-controller-create-subscription';
import { subscriptionsControllerCreateSubscriptionSession } from '../fn/subscriptions/subscriptions-controller-create-subscription-session';
import { SubscriptionsControllerCreateSubscriptionSession$Params } from '../fn/subscriptions/subscriptions-controller-create-subscription-session';
import { subscriptionsControllerUpdatePlan } from '../fn/subscriptions/subscriptions-controller-update-plan';
import { SubscriptionsControllerUpdatePlan$Params } from '../fn/subscriptions/subscriptions-controller-update-plan';

@Injectable({ providedIn: 'root' })
export class SubscriptionsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `subscriptionsControllerCreateSubscription()` */
  static readonly SubscriptionsControllerCreateSubscriptionPath = '/keus-payments/subscriptions';

  /**
   * Create a new subscription product.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `subscriptionsControllerCreateSubscription()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  subscriptionsControllerCreateSubscription$Response(params: SubscriptionsControllerCreateSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return subscriptionsControllerCreateSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a new subscription product.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `subscriptionsControllerCreateSubscription$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  subscriptionsControllerCreateSubscription(params: SubscriptionsControllerCreateSubscription$Params, context?: HttpContext): Observable<void> {
    return this.subscriptionsControllerCreateSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `subscriptionsControllerCreateSubscriptionSession()` */
  static readonly SubscriptionsControllerCreateSubscriptionSessionPath = '/keus-payments/subscriptions/{priceId}/checkout-session';

  /**
   * Create a new subscription session.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `subscriptionsControllerCreateSubscriptionSession()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  subscriptionsControllerCreateSubscriptionSession$Response(params: SubscriptionsControllerCreateSubscriptionSession$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return subscriptionsControllerCreateSubscriptionSession(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a new subscription session.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `subscriptionsControllerCreateSubscriptionSession$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  subscriptionsControllerCreateSubscriptionSession(params: SubscriptionsControllerCreateSubscriptionSession$Params, context?: HttpContext): Observable<void> {
    return this.subscriptionsControllerCreateSubscriptionSession$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `subscriptionsControllerUpdatePlan()` */
  static readonly SubscriptionsControllerUpdatePlanPath = '/keus-payments/subscriptions/portal-session';

  /**
   * Create a new subscription session.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `subscriptionsControllerUpdatePlan()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  subscriptionsControllerUpdatePlan$Response(params: SubscriptionsControllerUpdatePlan$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return subscriptionsControllerUpdatePlan(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a new subscription session.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `subscriptionsControllerUpdatePlan$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  subscriptionsControllerUpdatePlan(params: SubscriptionsControllerUpdatePlan$Params, context?: HttpContext): Observable<void> {
    return this.subscriptionsControllerUpdatePlan$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `subscriptionsControllerCancelAllSubscriptions()` */
  static readonly SubscriptionsControllerCancelAllSubscriptionsPath = '/keus-payments/subscriptions/{customerId}/subscriptions';

  /**
   * Cancels a subscription for a customer.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `subscriptionsControllerCancelAllSubscriptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  subscriptionsControllerCancelAllSubscriptions$Response(params: SubscriptionsControllerCancelAllSubscriptions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    return subscriptionsControllerCancelAllSubscriptions(this.http, this.rootUrl, params, context);
  }

  /**
   * Cancels a subscription for a customer.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `subscriptionsControllerCancelAllSubscriptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  subscriptionsControllerCancelAllSubscriptions(params: SubscriptionsControllerCancelAllSubscriptions$Params, context?: HttpContext): Observable<Array<string>> {
    return this.subscriptionsControllerCancelAllSubscriptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

}
